export default function useVariant(styles) {
  return ({ variant = 'brand' }) => {
    let color
    let bg
    let hover

    if (!variant || variant === 'neutral') {
      color = styles.colors.palette.neutral.light
      hover = styles.colors.palette.paper.hover
      bg = styles.colors.palette.paper.base
    } else {
      color = styles.colors.palette.white.base
      hover = styles.colors.palette[variant].hover
      bg = styles.colors.palette[variant].base
    }

    return {
      color,
      bg,
      hover,
    }
  }
}
